import * as Yup from "yup";
import { emailErrorMessage } from "../../utils/validationMessage";

const Schema = Yup.object().shape({
  username: Yup.string().email(emailErrorMessage).required(emailErrorMessage),
});

export default Schema;
